import React, { ReactNode } from 'react';
import { Card, CardContent, Grid, makeStyles, Theme, Typography } from '@material-ui/core';
import clsx from 'clsx';
import { RetailCloseButton } from 'components/retail/atoms';

interface CardBoxProps {
  children: ReactNode;
  cardSpacing?: boolean;
  headerButtonExist?: boolean;
  title: string;
  mutedTitle?: string;
  onClose?: () => void;
  className?: string;
}

const useStyles = makeStyles((theme: Theme) => {
  return {
    cardSpacing: {
      marginBottom: theme.spacing(3.75),
      [theme.breakpoints.up('md')]: {
        marginBottom: theme.spacing(2.5),
      },
    },
    formTitleWrapper: {
      padding: theme.spacing(2.5, 2.5, 1.25),
      [theme.breakpoints.up('sm')]: {
        borderBottom: '1px solid #EAEAEA',
        padding: theme.spacing(2.375, 2.5),
      },
      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(2.375, 3),
      },
    },
    formTitleWrapperSolo: {
      padding: theme.spacing(2.5),
      borderBottom: '1px solid #EAEAEA',
      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(2.375, 2.5),
      },
      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(2.5, 3),
      },
    },
    formTitleText: {
      fontSize: theme.spacing(2.25),
      fontWeight: 600,
      color: '#000',
      lineHeight: 'normal',
    },
    mutedTitle: {
      marginLeft: theme.spacing(0.5),
      color: theme.palette.secondary.light,
    },
  };
});

const CardBox: React.FC<CardBoxProps> = ({
  children,
  title,
  cardSpacing,
  headerButtonExist,
  mutedTitle,
  onClose,
  className = '',
}) => {
  const classes = useStyles();

  return (
    <>
      <Card className={clsx(cardSpacing ? classes.cardSpacing : false, className)}>
        <Grid
          container
          spacing={0}
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          className={clsx(
            classes.formTitleWrapper,
            headerButtonExist ? false : classes.formTitleWrapperSolo
          )}
        >
          <Typography className={classes.formTitleText} variant={'h3'}>
            {title}
            <span className={classes.mutedTitle}>{mutedTitle}</span>
          </Typography>
          {onClose ? <RetailCloseButton onClick={onClose} /> : null}
        </Grid>
        <CardContent>{children}</CardContent>
      </Card>
    </>
  );
};

export default CardBox;
